import React, { useRef, useState } from 'react';
import Papa from 'papaparse';
import { useDispatch } from 'react-redux';
import { updateReferrerSuccessCSVList, updateReferrerFailedCSVList } from '@store/Business/business';
import { UploadOutlined } from '@ant-design/icons';
import { separateRecords } from '@utils/comman';

interface CsvFileInputProps {
    onFileLoad: (data: any[]) => void;
}

const CsvFileInput: React.FC<CsvFileInputProps> = ({ onFileLoad }) => {
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true)
        const file = e.target.files?.[0];
        if (file) {
            Papa.parse<any>(file, {
                complete: (result) => {
                    // **** will use later on ************ //
                    // const transformedData = result.data.map((row, index) => {
                    //     if (index === 0) {
                    //         return Object.keys(row).reduce((acc: any, key: string) => {
                    //             const newKey = key.replace(/_/g, ' ').toUpperCase();
                    //             acc[newKey] = row[key];
                    //             return acc;
                    //         }, {});
                    //     }
                    //     return row;
                    // });
                    onFileLoad(result.data);
                    setIsLoading(false);
                },
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
            });
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <div>
            <button className='btn btn-primary' onClick={handleButtonClick} disabled={isLoading}>{isLoading ? "Wait Uploading ..." : `Upload CSV`} <UploadOutlined /> </button>
            <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                ref={fileInputRef}
                style={{ display: 'none' }} // Hide the file input
            />
        </div>
    );
};

const CSVUploader: React.FC = () => {
    const dispatch = useDispatch()

    const handleFileLoad = (csvData: any[]) => {
        const { validRecords, invalidRecords } = separateRecords(csvData);
        dispatch(updateReferrerSuccessCSVList(validRecords))
        dispatch(updateReferrerFailedCSVList(invalidRecords))
    };

    return (
        <div>
            <CsvFileInput onFileLoad={handleFileLoad} />
        </div>
    );
};

export default CSVUploader;